module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAWCAYAAAChWZ5EAAAAAXNSR0IArs4c6QAAAWdJREFUSEvNlqFPw1AQxr+vHUsFBjU3uWxp91QNs1OQEBSKoAkKgcAyDA6FXIIEHGaGJSRYmNje+ztQFaQh4QiEkhIY73VZ1tXed9/92te7e0TJD13rG2NqAK5E5FApZVzzbDongNFoVA+CYCgiDRG5V0p1bcaucSvAeDxu+L4/BFAn+ej7/mar1Xp2LWDT/QtgjFEA7gDUROShWq1uNZvNxGZaJD4VQGu9TnIAYA3AIEmSnU6n81LE3EX7J8BkMul6nncLYBXATZqme3Ecv7oYFtX8AtBab5O8BhAA6EdRtE/yraixq/4HgNZ6l+QlgBWS51EUHbkazar7BjDGHAC4AEAROVFKnc5qWiTvE0BrfUzy7CvR2ppFCti0ywHwQZk/AgC9drvds9HPI748P2H2Nvk2JNkPw3BxbZhBlDqIcl+ivFGcQZS6jDKI/DoG8FSpVDYWto4ziFIvJLnjKO9KNo+BM83jHdnfkgc8CQlNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/left.png
// module id = xDWF
// module chunks = 1